import BasePage from '@/found/components/table_page';
import FileForm from '../file/detail.vue';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        budgetId: this.paramsProps.budgetId,
      },
    };
  },
  components: {
    FileForm,
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'view_attachments') {
        this.formName = 'FileForm';
        this.formConfig = {
          batchId: row.batchId,
        };
        this.modalConfig.title = '查看附件';
        this.openDrawer();
      }
    },
  },
  created() {
    this.getConfigList('log-list');
  },
};
